import { OTA_ArrivalDetails } from "./ota_arrivaldetails.model";
import { OTA_RentalPaymentPref } from "./ota_rentalpaymentpref.model";
import { OTA_CoveragePref } from "./ota_coveragepref.model";
import { OTA_OffLocService } from "./ota_offlocservice.model";

export class OTA_VehResRQInfo {
    public arrivalDetails = new OTA_ArrivalDetails();
    public rentalPaymentPref = new OTA_RentalPaymentPref();
    public coveragePrefs = new Array<OTA_CoveragePref>();
    public offLocServices = new Array<OTA_OffLocService>();
}
